import { isStaffBrowser } from './adminAuth';

const API = process.env.REACT_APP_BACKEND_URL;

/** Records a homepage call-to-action click; uses sendBeacon so it survives the page change. */
export const trackCtaClick = (cta) => {
  if (isStaffBrowser()) return;
  const body = JSON.stringify({ cta, page: window.location.pathname });
  try {
    if (navigator.sendBeacon) navigator.sendBeacon(`${API}/api/analytics/cta-click`, new Blob([body], { type: 'application/json' }));
    else fetch(`${API}/api/analytics/cta-click`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true }).catch(() => {});
  } catch {
    // never block navigation
  }
};
